import React from 'react'
import { Modal } from 'react-bootstrap'
import { ITransactionLog } from '../../core/response.types'
import { DIRECTION_BADGE, DIRECTION_LABEL } from '../../core/consts'
import { PayloadViewer } from './PayloadViewer'
import { convertUTCtoMSK } from '../../../../../../../utils'

interface LogDetailsModalProps {
  log: ITransactionLog | null
  onHide: () => void
}

export const LogDetailsModal: React.FC<LogDetailsModalProps> = ({ log, onHide }) => {
  return (
    <Modal show={!!log} onHide={onHide} size='xl' centered>
      <Modal.Header closeButton>
        <Modal.Title className='fs-5 fw-bold'>Детали лога</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {log && (
          <div className='d-flex flex-column gap-5'>
            <div className='row g-4'>
              <div className='col-md-4'>
                <div className='fw-bold text-muted mb-1'>Дата</div>
                <div>{convertUTCtoMSK(log.created_at)}</div>
              </div>
              <div className='col-md-4'>
                <div className='fw-bold text-muted mb-1'>Направление</div>
                <span className={`badge ${DIRECTION_BADGE[log.direction]}`}>
                  {DIRECTION_LABEL[log.direction]}
                </span>
              </div>
              {log.duration_ms !== null && (
                <div className='col-md-4'>
                  <div className='fw-bold text-muted mb-1'>Длительность</div>
                  <div>{(log.duration_ms / 1000).toFixed(3)} с</div>
                </div>
              )}
              {log.status_code !== null && (
                <div className='col-md-4'>
                  <div className='fw-bold text-muted mb-1'>Статус</div>
                  <span
                    className={`badge ${log.status_code >= 200 && log.status_code < 300 ? 'badge-light-success' : 'badge-light-danger'}`}
                  >
                    {log.status_code >= 200 && log.status_code < 300
                      ? `OK (${log.status_code})`
                      : `ERROR (${log.status_code})`}
                  </span>
                </div>
              )}
              {log.kind && (
                <div className='col-md-4'>
                  <div className='fw-bold text-muted mb-1'>Kind</div>
                  <div>{log.kind}</div>
                </div>
              )}
              {log.url && (
                <div className='col-12'>
                  <div className='fw-bold text-muted mb-1'>URL</div>
                  <div
                    style={{
                      fontFamily: 'monospace',
                      fontSize: '0.85rem',
                      wordBreak: 'break-all',
                    }}
                  >
                    {log.url}
                  </div>
                </div>
              )}
              {log.error && (
                <div className='col-12'>
                  <div
                    style={{
                      border: '1px solid var(--bs-danger)',
                      background: 'rgba(var(--bs-danger-rgb), 0.08)',
                      borderRadius: '6px',
                      padding: '10px 14px',
                      color: 'var(--bs-danger)',
                      fontSize: '0.85rem',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-all',
                      fontFamily: 'monospace',
                    }}
                  >
                    {log.error}
                  </div>
                </div>
              )}
            </div>
            <PayloadViewer content={log.request} label='Request' />
            <PayloadViewer content={log.response} label='Response' />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type='button' className='btn btn-light' onClick={onHide}>
          Закрыть
        </button>
      </Modal.Footer>
    </Modal>
  )
}
